import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { Toast } from '../NarusMaterial'

interface EligibleToastProps {
  id: string
  clientName: string
  patientId: string
  firstName: string
  lastName: string
  close: (id: string) => void
}

export function EligibleToast ({ id, clientName, patientId, firstName, lastName, close }: EligibleToastProps): JSX.Element {
  const navigate = useNavigate()

  const handleClose = useCallback((): void => {
    close(id)
  }, [ close, id ])

  function handleCardClick (): void {
    navigate(`/patient/${clientName}/${patientId}/patientFolder`)
  }

  return (
    <Toast
      onDelete={handleClose}
    >
      <Content
        onClick={handleCardClick}
        firstName={firstName}
        lastName={lastName}
      />
    </Toast>
  )
}

interface ContentProps {
  firstName: string
  lastName: string
  onClick: () => void
}

function Content ({ firstName, lastName, onClick }: ContentProps): JSX.Element {
  return (
    <button
      onClick={onClick}
      className='cursor-pointer'
    >
      <h2>No longer eligible</h2>
      <p>{firstName}, {lastName} is no longer eligible</p>
    </button>
  )
}
